/**
 * Sidebar navigation configuration
 * Each item represents a navigation link in the sidebar
 */
export default [
  {
    id: 'dashboard',
    label: 'Dashboard',
    translationKey: 'sidebar.dashboard',
    path: '/dashboard',
    icon: 'fas fa-chart-bar',
    requiredPermission: 'DASHBOARD_PAYMENTS_READ',
    industries: ['commerce', 'medical', 'school', 'levies', 'personal'],
    activePaths: ['/dashboard', '/dashboard/payments', '/dashboard/sales', '/dashboard/invoices', '/dashboard/sms'],
    hidden: false
  },
  {
    id: 'appointments',
    label: 'Appointments',
    translationKey: 'sidebar.accessControl',
    path: '/appointments',
    icon: 'fas fa-calendar-check',
    requiredPermission: 'CUSTOMERS_READ',
    industries: ['medical'],
    activePaths: ['/appointments'],
    hidden: false
  },
  {
    id: 'contacts',
    label: 'Contacts',
    translationKey: 'sidebar.owners',
    path: '/contacts',
    icon: 'fas fa-users',
    requiredPermission: 'CUSTOMERS_READ',
    industries: ['levies'],
    activePaths: ['/contacts/'],
    hidden: false
  },
  {
    id: 'invoices',
    label: 'Invoices',
    translationKey: 'sidebar.invoices',
    path: '/invoices',
    icon: 'fas fa-file-invoice-dollar',
    requiredPermission: 'INVOICES_READ',
    industries: ['commerce', 'medical', 'school', 'levies'],
    activePaths: ['/invoices'],
    hidden: false
  },
  {
    id: 'receipts',
    label: 'Payments',
    translationKey: 'sales.payments',
    path: '/receipts',
    icon: 'fas fa-receipt',
    requiredPermission: 'RECEIPTS_READ',
    industries: ['commerce', 'medical', 'school', 'levies', 'personal'],
    activePaths: ['/receipts'],
    hidden: false
  },
  {
    id: 'statement',
    label: 'Statement',
    translationKey: 'sidebar.statement',
    path: '/statement',
    icon: 'fas fa-file-alt',
    requiredPermission: 'CUSTOMERS_READ',
    industries: ['commerce', 'medical', 'school', 'levies', 'personal'],
    activePaths: ['/statement'],
    hidden: false
  },
  {
    id: 'visits',
    label: 'Visitors',
    translationKey: 'sidebar.accessControl',
    path: '/visits',
    icon: 'fas fa-calendar-check',
    requiredPermission: 'VISITS_READ',
    industries: ['levies'],
    activePaths: ['/visits', '/visitors'],
    hidden: false
  },
  {
    id: 'contractors',
    label: 'Service Providers',
    translationKey: 'sidebar.contractors',
    path: '/contractors',
    icon: 'fas fa-hard-hat',
    requiredPermission: 'VISITS_READ',
    industries: ['levies'],
    activePaths: ['/contractors'],
    hidden: false
  },
  {
    id: 'owners',
    label: 'Residents',
    translationKey: 'sidebar.owners',
    path: '/contacts',
    icon: 'fas fa-users',
    requiredPermission: 'CUSTOMERS_READ',
    industries: ['levies'],
    activePaths: ['/owners', '/contacts/'],
    hidden: false
  },
  {
    id: 'communications',
    label: 'Communications',
    translationKey: 'sidebar.communications',
    path: '/communications',
    icon: 'fas fa-bullhorn',
    requiredPermission: 'SETTINGS_READ',
    description: 'Manage email and sms',
    industries: ['levies', 'school', 'medical'],
    activePaths: ['/communications'],
    hidden: true
  },
  {
    id: 'settings',
    label: 'Settings',
    translationKey: '',
    path: '/settings/profile',
    icon: 'fas fa-cog',
    requiredPermission: null,
    industries: ['commerce', 'medical', 'school', 'levies'],
    activePaths: [
      '/settings/profile',
      '/settings/security',
      '/settings/preferences'
    ],
    hidden: false
  }
];



// WEBPACK FOOTER //
// ./src/config/sidebarNavigation.js